import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { IPickup } from '@/models/regions.model';
import { DEFAULT_LOCALE } from '@/models/localization.model';
import { StyledBadge } from '@/components';
import PickupLocationsTableActions from '../PickupLocationsTableActions/PickupLocationsTableActions';

type TGetPickupTableColumns = {
  t: TFunction;
  onDelete: (item: IPickup) => void;
  onUpdate: (item: IPickup) => void;
  canManage: boolean;
};

export const getPickupTableColumns = ({
  t,
  onDelete,
  onUpdate,
  canManage,
}: TGetPickupTableColumns): ColumnsType<IPickup> => {
  return [
    {
      title: t('pickup_region'),
      dataIndex: 'regionName',
      key: 'regionName',
      render: (_, record) => <span>{record?.settlement?.region?.name}</span>,
    },
    {
      title: t('pickup_city'),
      dataIndex: 'cityName',
      key: 'cityName',
      render: (_, record) => <span>{record?.settlement?.name}</span>,
    },
    {
      title: t('pickup_address'),
      dataIndex: 'address',
      key: 'address',
      render: (_, record) => record?.locale?.[DEFAULT_LOCALE]?.address,
    },
    {
      title: t('pickup_schedule'),
      dataIndex: 'working_hours',
      key: 'working_hours',
      render: (_, record) => record?.locale?.[DEFAULT_LOCALE]?.working_hours,
    },
    {
      title: t('pickup_phone_number'),
      dataIndex: 'phone',
      key: 'phone',
      render: (phone) => <span>{phone}</span>,
    },
    {
      title: t('pickup_main'),
      dataIndex: 'is_default',
      key: 'is_default',
      render: (is_default) => (
        <StyledBadge $isActive={is_default}>
          {is_default ? t('region_settlements_yes') : t('region_settlements_no')}
        </StyledBadge>
      ),
    },
    {
      title: t('regions_list_active'),
      dataIndex: 'is_active',
      key: 'is_active',
      render: (is_active) => (
        <StyledBadge $isActive={is_active}>
          {is_active ? t('region_settlements_yes') : t('region_settlements_no')}
        </StyledBadge>
      ),
    },
    ...(canManage
      ? [
          {
            title: t('regions_table_actions'),
            key: 'actions',
            render: (_: unknown, record: IPickup) => (
              <PickupLocationsTableActions pickup={record} onDelete={onDelete} onUpdate={onUpdate} />
            ),
          },
        ]
      : []),
  ];
};
